<template>
    <div class="videoimg" >
        <img :src="videoList" alt="">
    </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
function getVideoList(vue) {
  let _this = vue;
  axios
    .post(
      "/wap/CurriHandle/curriList",
      qs.stringify({
        bookId: _this.$route.params.id
      })
    )
    .then(function (res) {
      //console.log(res.data.data.brief);
      _this.videoList = res.data.data.brief;
    })
    ["catch"](function (error) {
      console.log(error);
    });
}
export default {
  name: "videoimg",
  data() {
    return {
      videoList: ""
    };
  },
  created() {
    getVideoList(this);
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.videoimg {
  width: 100%;
  img {
    display: block;
    width: 94%;
    margin: 20px;
  }
}
</style>
